import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { SubscriptionManagementPageApp } from './components/subscription-management-page-app'

const subscriptionManagementPageApp = document.getElementById('subscription-management-app');

if (subscriptionManagementPageApp != undefined) {
    const subscriptionManagmentRoot = createRoot(subscriptionManagementPageApp);
    const anyWindow = window as any;

    const addresses = JSON.parse(anyWindow.bootstrap.addresses.replace(/&quot;/g, '"'));

    subscriptionManagmentRoot.render(
        <SubscriptionManagementPageApp
            contentId={anyWindow.bootstrap.contentId}
            addresses={addresses} />
    );
}